import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "reactstrap";
import { useLoginStatus } from "../../../Layout/AppMain/LoginStatusContext";

import { DropdownList } from "react-widgets";

import Mixed from "./Components/Mixed";
import ChangeGraph from "./Components/ChangeGraph";
import PieChart from "./Components/pie";
import { Link } from "react-router-dom";
import * as Ionicons from "react-icons/io";
import { useQuery } from "@apollo/client";
import { GET_ORG_ANNUAL_DATA } from "../../../queries";

import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";

const SettingOrgTab3 = ({
  obj,
  orgId,
  all_fiscal_year,
  default_fiscal_year,
}) => {
  const loginStatus = useLoginStatus();

  const LockIcon = Ionicons["IoIosLock"];
  const KeyIcon = Ionicons["IoIosKey"];

  const [fiscalYear, setFiscalYear] = useState(default_fiscal_year);

  const { loading, error, data } = useQuery(GET_ORG_ANNUAL_DATA, {
    variables: { fiscalYear: fiscalYear, id: orgId },
  });

  let doropdownData = all_fiscal_year.map((ary) => ({
    id: ary,
    color: `${ary}年度`,
  }));

  let dropdownDataOrder = doropdownData.sort((a, b) => {
    return a.id > b.id ? -1 : 1;
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) return "...error";
  if (!data) return "...Not Found";

  const { annualData } = data.allOrgaccount.edges[0].node;

  return (
    <div>
      {annualData.edges.length === 0 ? (
        <div>
          <div className="mb-2 mt-4 flex-ai-center">
            <h6 className="mb-0 mr-4 ml-2 bold">財務データ</h6>
            <DropdownList
              data={dropdownDataOrder}
              value={fiscalYear}
              dataKey="id"
              textField="color"
              defaultValue={""}
              onChange={(e) => setFiscalYear(e.id)}
              style={{ width: 200 }}
            />
          </div>
          <Card className="mb-3  org_contentarea">
            <div>データがありません</div>
          </Card>
        </div>
      ) : (
        <div>
          <div>
            <div className="mb-2 mt-4 flex-ai-center">
              <h6 className="mb-0 mr-4 ml-2 bold">財務データ</h6>
              <DropdownList
                data={dropdownDataOrder}
                value={fiscalYear}
                textField="color"
                defaultValue={"2019年度"}
                onChange={(e) => setFiscalYear(e.id)}
                style={{ width: 200 }}
              />
            </div>
            <Card className="mb-3  org_contentarea">
              <Row>
                {annualData.edges.map((array) => (
                  <Col sm="12">
                    <h6 className="mb-4 mr-4 ml-3 bold">
                      {array.node.financialStatementName}
                    </h6>
                    <div className="org_item">
                      <Row>
                        <Col sm="12" lg="6">
                          <p className="finance_subtitle pl-1 pb-2">経常収益</p>
                          <table className="org_item_table finance_table ml-1">
                            <tr>
                              <th>会費</th>
                              <td>{array.node.memberFee}</td>
                            </tr>
                            <tr>
                              <th>寄付</th>
                              <td>{array.node.donation}</td>
                            </tr>
                            <tr>
                              <th>自主事業</th>
                              <td>{array.node.businessRevenue}</td>
                            </tr>
                            <tr>
                              <th>受託事業</th>
                              <td>{array.node.trusteeRevenue}</td>
                            </tr>
                            <tr>
                              <th>助成金</th>
                              <td>{array.node.subsidy}</td>
                            </tr>
                            <tr>
                              <th>補助金</th>
                              <td>{array.node.bounty}</td>
                            </tr>
                            <tr>
                              <th>その他収益</th>
                              <td>{array.node.miscellaneous}</td>
                            </tr>
                            <tr className="total_box">
                              <th>合計</th>
                              <td>
                                {array.node.totalOrdinaryRevenue.replace(
                                  /(\d)(?=(\d\d\d)+(?!\d))/g,
                                  "$1,"
                                )}
                              </td>
                            </tr>
                          </table>
                        </Col>
                        <Col sm="12" lg="6" className="mt-4">
                          <PieChart
                            revenueData={array.node}
                            dataType="経常収益"
                          />
                        </Col>
                        <Col sm="12" lg="6" className="mt-5">
                          <p className="finance_subtitle mt-4 pl-1 pb-2">
                            経常費用
                          </p>
                          <table className="org_item_table finance_table ml-1">
                            <tr>
                              <th>事業費・人件費</th>
                              <td>{array.node.expenceProjectPersonnel}</td>
                            </tr>
                            <tr>
                              <th>事業費・その他</th>
                              <td> {array.node.expenceProjectOther}</td>
                            </tr>
                            <tr>
                              <th>事業費合計</th>
                              <td> {array.node.totalExpensesProject}</td>
                            </tr>
                            <tr>
                              <th>管理費・人件費</th>
                              <td>
                                {array.node.expensesAdministrativeHumanOther}
                              </td>
                            </tr>
                            <tr>
                              <th>管理費・その他</th>
                              <td> {array.node.expensesAdministrativeOther}</td>
                            </tr>
                            <tr>
                              <th>管理費・合計</th>
                              <td> {array.node.totalAdministrativeExpenses}</td>
                            </tr>
                            <tr className="total_box">
                              <th>合計</th>
                              <td>{array.node.totalOrdinaryExpenses}</td>
                            </tr>
                          </table>
                        </Col>
                        <Col sm="12" lg="6" style={{ marginTop: 100 }}>
                          <PieChart
                            revenueData={array.node}
                            dataType="経常費用"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
                <Col sm="12" className="mt-4 mb-1">
                  <div className="org_item">
                    <Row>
                      {annualData.edges.map((array) => (
                        <Col sm="12" lg="6">
                          <table className="org_item_table finance_table ml-1">
                            <tr>
                              <th>当期経常増減額</th>
                              <td>{array.node.netDecreaseOrdinaryIncome}</td>
                            </tr>
                            <tr>
                              <th>経常外収益計</th>
                              <td>{array.node.totalNonOrdinaryIncome}</td>
                            </tr>

                            <tr>
                              <th>経常外費用計</th>
                              <td>{array.node.totalNonOrdinaryExpenses}</td>
                            </tr>
                            <tr>
                              <th>当期正味財産増減額</th>
                              <td>{array.node.changeNetAssets}</td>
                            </tr>
                          </table>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>

                <Col sm="12" className="mt-5 mb-2">
                  <h6 className="mb-4 mr-4 ml-3 bold">貸借対照表</h6>
                  <div className="org_item">
                    <Row>
                      {annualData.edges.map((array) => (
                        <Col sm="12" lg="6">
                          <p className="finance_subtitle pl-1 pb-2">資産の部</p>
                          <table className="org_item_table finance_table ml-1">
                            <tr>
                              <th>流動資産</th>
                              <td>{array.node.currentAssets}</td>
                            </tr>
                            <tr>
                              <th>固定資産</th>
                              <td>{array.node.fixedAssets}</td>
                            </tr>
                            <tr className="total_box">
                              <th>資産合計</th>
                              <td>{array.node.totalAssets}</td>
                            </tr>
                          </table>
                          <p className="finance_subtitle mt-4 pl-1 pb-2">
                            負債・正味財産の部
                          </p>
                          <table className="org_item_table finance_table ml-1">
                            <tr>
                              <th>流動負債</th>
                              <td>{array.node.currentLiabilities}</td>
                            </tr>
                            <tr>
                              <th>固定負債</th>
                              <td>{array.node.fixedLiabilities}</td>
                            </tr>
                            <tr className="total_box">
                              <th>負債合計</th>
                              <td>{array.node.totalLiabilities}</td>
                            </tr>
                            <tr>
                              <th>正味財産合計</th>
                              <td>{array.node.netAssetsEndYear}</td>
                            </tr>
                            <tr className="total_box">
                              <th>負債・正味財産合計</th>
                              <td>{array.node.totalLiabilitiesNetAssets}</td>
                            </tr>
                          </table>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
      )}

      <div>
        <h6 className="mb-3 ml-2 bold">収入の経年変化</h6>
      </div>

      <Card className="mb-3 org_contentarea">
        <Row>
          {loginStatus ? (
            <Col sm="12" style={{ position: "relative" }}>
              <Mixed orgId={orgId} />
            </Col>
          ) : (
            <Col sm="12" style={{ position: "relative", height: 300 }}>
              <div className="needLogin">
                <div className="item">
                  <p className="message ema__flex ema__align_items_center">
                    <LockIcon fontSize="30px" />
                    サインアップして分析結果を見る
                  </p>
                  <button
                    className="ema__btn__signup"
                    style={{ margin: "auto" }}
                  >
                    <Link
                      to="/pages/login"
                      style={{
                        marginRight: 10,
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      <KeyIcon fontSize="23px" />
                      サインアップ
                    </Link>
                  </button>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </Card>
    </div>
  );
};

export default SettingOrgTab3;
